<template>
    <div class="home">
      <el-image :src="require('@/assets/tmp/partyBuilding.jpg')" style="width: 100%"></el-image>
<!--      <div class="top">-->
<!--      </div>-->
      <div class="details">
        <div style="width: 90%;margin-left: 5%;display: flex;padding-top: 5rem;  align-items: center;justify-content: center;text-align: center">
          <div style="width: 40%;background-color: #707070;height: 0.1rem"></div>
          <div style="width: 20%;font-size: 1.5rem;font-weight: 700;color: #6c1414">党建活动</div>
          <div style="width: 40%;background-color: #707070;height: 0.1rem"></div>
        </div>
        <div  :class="['news-details',item.isHovered ? 'hover-shadow':'']" v-for="item in dataList" :key="item.id" @click="toDetails(item)" @mouseenter="changeShadow(item)" @mouseleave="changeShadow(item)">
          <div class="details2" >
            <div style="width: 80%">
              <div :style="{fontSize :item.isHovered ? '21px':'',color:item.isHovered ? '#1196db':''}" class="details_title" v-bind:title="item.title">{{item.title}}</div>
              <div style="color: #bfbfbf ;font-size: 0.8rem; overflow: hidden;text-overflow: ellipsis;white-space: nowrap;" v-bind:title="item.summary">{{item.summary}}</div>
            </div>
<!--            <div style="margin-top: 5rem;width: 80%;font-size: 1rem;font-weight: 100;color: #bfbfbf;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">{{item.introduction}}</div>-->
          </div>
          <div :style="{
              color:item.isHovered ? '#1196db':''
            }" class="details-button">点击详情</div>
        </div>
        <div style="width: 100%;text-align: center">
          <el-pagination
              background
              style="text-align: center"
              layout="prev, pager, next"
              :total="total"
              :current-page="queryParams.pageNum"
              :page-size="queryParams.pageSize"
              @current-change="handleCurrentChange">
          </el-pagination>
        </div>
      </div>
  </div>
</template>

<script>
import {getArticleList} from "@/api/article";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "index",
  data(){
    return {
      dataList:[],
      total:undefined,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        category:6,
        status:true
      },
    }
  },
  mounted() {
    this.getList()
  },
  beforeRouteLeave(to, from, next) {
    // 保存滚动位置到 Vue Router 的 meta 字段
    if (this.$el) {
      from.meta.savedPosition = {
        x: window.pageXOffset,
        y: window.pageYOffset,
      };
    }
    next();
  },
  methods: {
    changeShadow(item) {
      item.isHovered = !item.isHovered;
    },
    toDetails(item){
      item.isHovered=!item.isHovered
      this.$router.push({path:"/partyBuilding/details",query:{id:item.id}})
    },
    handleCurrentChange(pageNum){
      this.queryParams.pageNum=pageNum
      this.getList()
    },
    getList(){
      getArticleList(this.queryParams).then(async res=>{
        const data=await  res.data.content
        for (let i = 0; i <data.length ; i++) {
          data[i].isHovered=false
        }
        this.dataList= data
        this.total=res.data.totalElements
      })
    },
  },
}
</script>

<style scoped>
.hover-shadow {
  /* 鼠标悬停时的阴影效果 */
  box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.1);
}
.details_title{
  /*padding-top: 2rem;*/
  color: #323233;
  line-height: 4rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.details-button{
  display: flex;
  cursor: pointer;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 竖直居中 */
  height: 100%; /* 确保父容器有足够的高度 */
  width: 15%;
  font-size: 11px;
  font-weight: 200;
}
.news-details{
  height: 7rem;
  display: flex;
  justify-content: center; /* 水平居中 */
  /*align-items: center; !* 竖直居中 *!*/
  border-bottom: 1px #eaeaea solid
}
.details2{
  width: 80%;
  /*padding-top: 2%;*/
  margin-left: 5%;
  /*cursor: pointer;*/
}
.details{
  width: 70%;
  background-color: white;
  margin-left: 15%;
}
.home{
  padding-top: 4rem;
  width: 100%;
  background-color: #efefef;
}
</style>
